'use client';

import React, { useEffect, useRef, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const spokes = [
  { label: 'About Us',       href: '#welding' },
  { label: 'Services',    href: '#palletizing' },
  { label: 'Projects',href: '#machine-tending' },
  { label: 'Markets',     href: '#inspection' },
  { label: 'Technology',       href: '#assembly-spec' },
];

export default function Header() {
  const [scrolled, setScrolled]       = useState(false);
  const [activeSpoke, setActiveSpoke] = useState('');
  const [menuOpen, setMenuOpen]       = useState(false);
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);

      // Active spoke detection
      for (const spoke of [...spokes].reverse()) {
        const el = document.getElementById(spoke.href.slice(1));
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120) {
            setActiveSpoke(spoke.href);
            return;
          }
        }
      }
      setActiveSpoke('');
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      ref={headerRef}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b backdrop-blur-md ${
        scrolled
          ? 'bg-white/70 border-[#F4B223]' : 'bg-white/70 border-[#F4B223]'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between gap-6">
        {/* Logo */}
        <div className="flex items-center gap-3 shrink-0">
          <a href="/" aria-label="Go to home page">
            <AppLogo
              size={170}
              iconName="CpuChipIcon"
              className="text-bone font-black tracking-widest2 text-sm"
            />
          </a>
        </div>

        {/* Project counter pill — removed */}

        {/* Spoke nav — desktop */}
        <nav className="hidden md:flex items-center gap-6 flex-1 justify-center">
          {spokes.map((s) => (
            <button
              key={s.href}
              onClick={() => handleNav(s.href)}
              className={`spoke-link bg-transparent border-0 cursor-pointer ${
                activeSpoke === s.href ? 'active' : ''
              }`}
            >
              {s.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#spec-your-cell"
          onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
          className="btn-furnace shrink-0 hidden sm:inline-flex"
        >
Say Hello
          <Icon name="ArrowRightIcon" size={14} className="text-white" />
        </a>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden text-bone-dim hover:text-bone transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-ink/98 border-t border-white/5 px-6 py-4 flex flex-col gap-3">
          {spokes.map((s) => (
            <button
              key={s.href}
              onClick={() => handleNav(s.href)}
              className="spoke-link bg-transparent border-0 cursor-pointer text-left w-full"
            >
              {s.label}
            </button>
          ))}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); setMenuOpen(false); }}
            className="btn-furnace mt-2 justify-center"
          >
Say Hello
          </a>
        </div>
      )}
    </header>
  );
}